import React from "react";
import AccommodationBanner
    from "@SearchResults/features/banners/features/accommodationBanner/components/AccommodationBanner";
import {BannerPropsType} from "@SearchResults/features/banners/features/getByTransferBanner/types/BannerProps.type"
import GetByTransferSearchResultsBanner
    from "@SearchResults/features/banners/features/getByTransferBanner/components/GetByTransferSearchResultsBanner";
import {useIsAircash} from "@Hooks/selector/useIsAircash";

type BottomBannerProps = BannerPropsType & {
    apiRoutesLoading: boolean,
    suggestionRoutesLoading: boolean,
    isCompanyStore: boolean,
}

function BottomBanners(props: BottomBannerProps) {
    const {
        hasActiveRoutes,
        transfersData,
        params,
        apiRoutesLoading,
        suggestionRoutesLoading,
        isCompanyStore,
    } = props

    const isAircash = useIsAircash()

    // Don't show GetByTransferSearchResultsBanner for Aircash stores
    const shouldShowGbtBanner = hasActiveRoutes && !isAircash

    return (
        <>
            {shouldShowGbtBanner && (
                <GetByTransferSearchResultsBanner
                    transfersData={transfersData}
                    snippetsAdditionalClassName="gb--cards-transfer-full"
                />
            )}

            {hasActiveRoutes && !apiRoutesLoading && !suggestionRoutesLoading && !isCompanyStore && (
                <AccommodationBanner
                    params={params}
                />
            )}
        </>
    );
}

export default BottomBanners;